import { compose } from "redux";
import { List } from "immutable";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { formValueSelector } from "redux-form/immutable";

import { DataState, LoadingDataState } from "altus-datastate";

import { EMPTY_LIST } from "app/app.constants";
import BasePage from "app/components/BasePage";
import { createGuid, renderContent } from "utils/app.util";
import SimpleFormModal from "app/components/SimpleFormModal";
import { withToggleModal } from "altus-ui-components";
import SortableList from "app/components/SortableList/SortableList";

class CrudBasePage extends PureComponent {
  constructor(props) {
    super(props);

    const { createEntityForm, editEntityForm } = props;

    if (createEntityForm) {
      this.createModalId = createGuid();
      this.createFormValueSelector = formValueSelector(createEntityForm.form);
    }

    if (editEntityForm) {
      this.editModalId = createGuid();
      this.editFormValueSelector = formValueSelector(editEntityForm.form);
    }
  }

  toggleCreateModal = () => {
    const { dispatchToggleModal } = this.props;
    dispatchToggleModal({ modalId: this.createModalId });
  };

  toggleEditModal = () => {
    const { dispatchToggleModal } = this.props;
    dispatchToggleModal({ modalId: this.editModalId });
  };

  render() {
    const {
      Icon,
      title,
      items,
      children,
      dataState,
      EditModalProps,
      editEntityForm,
      addButtonOnClick,
      CreateModalProps,
      createEntityForm,
      displayAddButton,
      SortableListProps,
      displaySearchField,
      EditEntityFormProps,
      CreateEntityFormProps,
      EditEntityFormComponent,
      CreateEntityFormComponent,
    } = this.props;

    return (
      <>
        <BasePage
          title={title}
          dataState={dataState}
          displayAddButton={displayAddButton}
          displaySearchField={displaySearchField}
          addButtonOnClick={addButtonOnClick || this.toggleCreateModal}
        >
          {SortableListProps && (
            <SortableList
              Icon={Icon}
              items={items}
              toggleEditModal={this.toggleEditModal}
              {...SortableListProps}
            />
          )}
          {renderContent(children, {
            toggleEditModal: this.toggleEditModal,
          })}
        </BasePage>
        {createEntityForm && (
          <SimpleFormModal
            Icon={Icon}
            form={createEntityForm}
            modalId={this.createModalId}
            FormProps={CreateEntityFormProps}
            component={CreateEntityFormComponent}
            formValueSelector={this.createFormValueSelector}
            {...CreateModalProps}
          />
        )}
        {editEntityForm && (
          <SimpleFormModal
            Icon={Icon}
            form={editEntityForm}
            modalId={this.editModalId}
            FormProps={EditEntityFormProps}
            component={EditEntityFormComponent}
            formValueSelector={this.editFormValueSelector}
            {...EditModalProps}
          />
        )}
      </>
    );
  }
}

CrudBasePage.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.instanceOf(List),
  dataState: PropTypes.oneOfType([
    PropTypes.instanceOf(DataState),
    PropTypes.instanceOf(List),
    PropTypes.arrayOf(PropTypes.instanceOf(DataState)),
  ]),

  SortableListProps: PropTypes.shape({
    getKey: PropTypes.func.isRequired,
    onRowClick: PropTypes.func,
    columns: PropTypes.arrayOf(
      PropTypes.shape({
        getSortProperty: PropTypes.func,
        getValue: PropTypes.func,
      }),
    ).isRequired,
  }),
};

CrudBasePage.defaultProps = {
  items: EMPTY_LIST,
  dataState: LoadingDataState,
};

export default compose(withToggleModal)(CrudBasePage);
